/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetExam = require('../services/GetExam');
var GetExamIdentifiers = require('../services/GetExamIdentifiers');
var GetInternalTasksByExam = require('../services/GetInternalTasksByExam');
var SecExamDashboardView = require('../views/SecExamDashboardView');

module.exports = function(examId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetExam(examId), GetExamIdentifiers(examId), GetInternalTasksByExam(examId))
    .done(function(exam, examIdentifiers, tasks) {
      NavUtils.navigate('#sec/exam/' + examId + '/dashboard');
      Scaffold.content.show(
        new SecExamDashboardView({
          model: new Backbone.Model({
            examIdentifiers: examIdentifiers,
            tasks: tasks,
            examId: examId,
            exam: exam
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
